import React, {ChangeEvent, useContext, useState} from 'react';
import {observer} from 'mobx-react-lite';
import {StoreContext} from '../base/root-store';
import excelEmployeesWithStructure from '../assets/files/business-unit-employee-template.xlsx';
import excelEmployeesWithManagers from '../assets/files/employee-manager-template.xlsx';
import {Button, Grid, GridColumn, Modal, ModalCloser, ModalContent, ModalFooter, ModalHeader} from '../../../patterns';

export const UploadEmployeesModal = observer((): JSX.Element => {
    const store = useContext(StoreContext).companyStore;
    const [excelFile, setExcelFile] = useState<File>();
    const errors = store.variables.excelValidationErrors;

    const handleFileChange = async (e: ChangeEvent<HTMLInputElement>): Promise<void> => {
        if (e.target.files) {
            setExcelFile(e.target.files[0]);
        }
    };
    const renderItems: () => JSX.Element[] = (): JSX.Element[] => errors.slice(0, 10).map((error: string, index: number) => (
        <li key={index} className="validation__message">{error}</li>
    ));

    const downloadFile = (path: string): void => {
        const a = document.createElement('a');

        a.style.display = 'none';
        a.href = path;

        if (path === excelEmployeesWithStructure) {
            a.download = 'business-unit-employee-template.xlsx';
        }
        if (path === excelEmployeesWithManagers) {
            a.download = 'employee-manager-template.xlsx';
        }
        document.body.appendChild(a);
        a.click();
    };

    const uploadFile = (): void => {
        const inputElement = document.getElementById('file-upload');

        store.cleanupExcelErrors();

        inputElement!.click();
    };

    return (
        <Modal size="small" onClose={(): void => store.cleanupExcelErrors()}>
            <ModalHeader>
                <h4>{store.label('company.actions.upload')}</h4>
            </ModalHeader>
            <ModalContent>
                <div className={'text'}>
                    <Button className={'button--block'} color={'white'}
                        text={'Business-Unit-Employee template'}
                        iconLeft={'download-arrow'}
                        onClick={(): void => downloadFile(excelEmployeesWithStructure)}/>

                    <p className="textfield__text-outside-fields">
                        {store.label('company.employee-modal.or')}
                    </p>
                    <Button className={'button--block'} color={'white'}
                        text={'Employee-Manager template'}
                        iconLeft={'download-arrow'}
                        onClick={(): void => downloadFile(excelEmployeesWithManagers)}/>
                    <input
                        id="file-upload"
                        type="file"
                        style={{display: 'none'}}
                        onChange={handleFileChange}
                        accept=".xlsx"
                    />
                    <div className={'border'}/>
                    <h5 className={'validation__message'}>{store.label('company.modal.upload.file.warning')}</h5>
                    <Button
                        text={store.label('company.modal.upload.file')}
                        onClick={uploadFile}
                        className="button button--block button--color-green-border"
                    />
                    <p><i>{excelFile?.name}</i></p>
                    <ul>
                        {store.variables.showValidation && store.variables.validationReason === 'incorrect_filetype' &&
                            <li className="validation__message"> {store.label('company.modal.excel.errors.file.type')}</li>}
                        {store.variables.showValidation && store.variables.validationReason === 'incorrect_format' &&
                            <li className="validation__message"> {store.label('company.modal.excel.errors.file.format')}</li>}
                        {renderItems()}
                    </ul>
                </div>
            </ModalContent>
            <ModalFooter>
                <Grid wrap={['xs']} justify={['center-xs']}>
                    <GridColumn width={['xs-12', 'sm-6']}>
                        <ModalCloser onClose={(): void => store.cleanupExcelErrors()}>
                            <Button block={true} color="white" text={store.label('common.modal.close')}/>
                        </ModalCloser>
                    </GridColumn>
                    <GridColumn width={['xs-12', 'sm-6']}>
                        <Button
                            block={true}
                            text={store.label('company.modal.save')}
                            disabled={!excelFile}
                            onClick={(): void => store.saveEmployeeExcel(excelFile)}
                        />
                    </GridColumn>
                </Grid>
            </ModalFooter>
        </Modal>
    );
});
